import React, { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Edit} from '@mui/icons-material'
import S from './ListDam.module.css'
import D from '../images/cow.svg'

import {  useSelector } from 'react-redux';
import { useGlobalContext } from '../Components/Context';
import EditPen from '../Components/editModalPen';
import DeletePen from '../Components/DeletePen';
import CreatePen from '../Components/createModalpen';

const moment=require('moment-jalaali')


const  SingleWarning=()=> {
  const {currentAdmin}=useSelector(state=>state.p.admin)
  const {currentPens}=useSelector(state=>state.pens)
 
  const [Value,setValue]=useState(0);
  const [allPens,setAllPens]=useState([])
  const {openModalls,isOpenModal,openDeleteModal,isDeleteModalOpen,isOpenModal2}=useGlobalContext();


  
 
  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} src={D}/>
        <h2> هشدار ها</h2>
        </div>
        
      </div>
        <hr/>
        <div className={S.TabForAllAnnimLICon}>
        {currentPens&&currentPens?.map((item,index)=>{
          return <div className={S.singleITem} key={index} >
          
          <div >
                {item.name}
            </div>
            <div style={{display:'flex',justifyContent:'space-between'}}>
        <div  className={S.EditBtnTableDam} onClick={()=>{openModalls();setValue(index)}}>
                <Edit/>
            </div>
            <div onClick={()=>{openDeleteModal();setValue(index)}}  className={S.DeleteBtnTableDam}>
                <DeleteIcon/>
            </div>
        </div>
        
        </div>
        })}
        </div>
        
        
        {isOpenModal&&<EditPen penr={currentPens[Value]} allPenss={allPens}/>}
        {isDeleteModalOpen&&<DeletePen penr={currentPens[Value]}/>}
        {isOpenModal2&&<CreatePen penr={currentPens[Value]} allPenss={allPens}/>}

    </div>
  );
}


export default SingleWarning